import {
  CastForEducationOutlined,
  Close,
  HomeWorkTwoTone,
  ListAltOutlined,
  LogoutOutlined,
  MarkChatReadRounded,
  PeopleAltOutlined,
  QuizOutlined,
  SettingsOverscanOutlined,
} from "@mui/icons-material";
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  Drawer,
  List,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaCode } from "react-icons/fa";
import { IoQrCodeSharp } from "react-icons/io5";

function SideBar({ handleLogout, mobileOpen, setMobileOpen, handleDrawerToggle }) {
  const navigate = useNavigate();
  const menuItems = [
    {
      label: "Overview",
      icon: <SettingsOverscanOutlined />,
      path: "/overview",
    },
    { label: "Students", icon: <PeopleAltOutlined />, path: "/students" },
    { label: "Lessons", icon: <CastForEducationOutlined />, path: "/lessons" },
    { label: "Codes", icon: <FaCode />, path: "/codes" },
    { label: "Attendance", icon: <IoQrCodeSharp />, path: "/attendance" },
    { label: "Homeworks", icon: <HomeWorkTwoTone />, path: "/homework" },
    { label: "Exams", icon: <QuizOutlined />, path: "/exam" },
    {
      label: "Education Stages",
      icon: <CastForEducationOutlined />,
      path: "/education-stages",
    },
    { label: "Centers", icon: <CastForEducationOutlined />, path: "/centers" },
    {label: "Results", icon: <MarkChatReadRounded/>, path: "/results"}
  ];
  const menuItems2 = [
    // {
    //   label: "Attendance Report",
    //   icon: <ListAltOutlined />,
    //   path: "/attendance-report",
    // },
    { label: "Logout", icon: <LogoutOutlined />, action: handleLogout },
  ];

  const drawerContent = (
    <Box sx={{ overflow: "auto" }}>
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton
              onClick={() => {
                navigate(item.path);

                if (window.innerWidth < 1200) handleDrawerToggle();
              }}
            >
              <ListItemIcon className="sidebar-icon">{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} className="sidebar-item" />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {menuItems2.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton
              onClick={() =>
                item.action ? item.action() : navigate(item.path)
              }
            >
              <ListItemIcon className="sidebar-icon">{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} className="sidebar-item" />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  return (
    <>
      <Box
        sx={{
          display: { xs: "none", lg: "block" },
        }}
      >
        <Drawer variant="permanent" open className="side-bar desktop-sidebar">
          <Toolbar />
          {drawerContent}
        </Drawer>
      </Box>
      <Box
        sx={{
          display: { xs: "block", lg: "none" },
        }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          className="side-bar mobile-sidebar"
        >
          <Toolbar />
          {drawerContent}
        </Drawer>
      </Box>
    </>
  );
}

export default SideBar;
